// extracted by mini-css-extract-plugin
module.exports = {"b1jncdej":"b1jncdej","i15oiujs":"i15oiujs","i1u2vg5i":"i1u2vg5i"};